<template>
  <div id="kpiList">
    <div class="content-header withgray">
      <i class="content-header-nav el-icon-arrow-left" @click="toBack"></i>
      {{this.title}}
      <el-button type="primary" class="content-header-filter" size="mini" @click="openFilter">筛选</el-button>
    </div>
    <div class="content-body withwhite">
      <div class="box">
        <div class="chart-summary" v-loading="chartLoading">
          <el-row>
            <el-col :span="24">
              <h3>{{this.chartTitle}}</h3>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              MN:
              <h1 class="box-target-value">{{this.totalDatas.MNTotal}}</h1>
            </el-col>
            <el-col :span="12">
              YL:
              <h1 class="box-target-value">{{this.totalDatas.YLTotal}}</h1>
            </el-col>
          </el-row>
        </div>
        <div class="chart" v-loading="chartLoading">
          <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
          <div id="main" style="width: 98%;height:400px;"></div>
        </div>
      </div>
    </div>
    <div class="content-footer">
      <el-radio-group v-model="teamTab" size="small" @change="changeHandler">
        <el-radio-button label="Date">时间维度</el-radio-button>
        <el-radio-button label="Region">区域维度</el-radio-button>
      </el-radio-group>
    </div>

    <el-dialog
      title="筛选"
      :visible.sync="showFilter"
      :show-close="false"
      customClass="customWidth"
      :close-on-click-modal="false"
    >
      <el-form :model="queryParams" size="mini" label-width="80px">
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="queryParams.sDate"
            type="date"
            format="yyyy年MM月dd日"
            :clearable="false"
            :editable="false"
            value-format="yyyy-MM-dd"
            placeholder="开始时间"
            class="fixwidth"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="queryParams.eDate"
            type="date"
            format="yyyy年MM月dd日"
            :clearable="false"
            :editable="false"
            value-format="yyyy-MM-dd"
            placeholder="结束时间"
            class="fixwidth"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属区域">
          <el-cascader
            style="width:50%;"
            ref="cas_region"
            :show-all-levels="false"
            change-on-select
            clearable
            :options="regionCascaders"
            v-model="regionIds"
            placeholder="请选择区域"
            class="fixwidth"
          ></el-cascader>
          <br />
          <i
            v-if="regionIds.length>0"
            class="el-dialog__close el-icon el-icon-close showfilter-region-clear"
            @click="clearRegion"
          >清空（默认全国）</i>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doFilter">完成筛选</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
  <script>
import {
  message,
  getBaseUrl,
  getKPIRegionCascaderOption,
  getReport1,
  getReportList
} from "../../api/api";
import libs from "../../utils/libs";
import moment from "moment";
import store from "../../utils/storage";
import echarts from "echarts";

const animationDuration = 6000;

export default {
  data() {
    return {
      uid: 0,
      teamTab: "Date",
      title: "",
      showFilter: false,
      searchLoading: false,
      chartLoading: false,
      regionCascaders: [],
      regionIds: [],
      queryParams: {
        sDate: moment()
          .subtract(8, "days")
          .format("YYYY-MM-DD"),
        eDate: moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD"),

        regionId: 0,
        userId: 1,
        reportModule: "",
        reportType: 1
      },
      tableDatas: [],
      totalDatas: {
        MNTotal: 0,
        YLTotal: 0
      },
      chartTitle: "",
      legendData: [],
      xAxisData: [],
      seriesData: [],
      dimensionsData: []
    };
  },
  mounted() {
    this.uid = this.$route.params.uid;
    this.queryParams.userId = this.$route.params.uid;
    this.title = this.$route.params.title;
    this.queryParams.reportModule = this.$route.params.module;
    //console.log(this.teamTab);
    this.getRegionCascader();
    //this.type=this.$route.params.type;
    //this.chartTitle=this.queryParams.sDate+'至'+this.queryParams.eDate;
    this.search();
  },
  methods: {
    toBack() {
      history.back();
    },
    changeHandler(value) {
      this.search();
    },
    openFilter() {
      this.showFilter = true;
    },
    clearRegion() {
      this.regionIds = [];
    },
    search() {
      this.chartLoading = true;
      this.queryParams.reportType = this.teamTab == "Date" ? 1 : 2;
      this.queryParams.regionId =
        this.regionIds.length > 0
          ? this.regionIds[this.regionIds.length - 1]
          : 0;
      getReportList(this.queryParams).then(res => {
        if (res.data.Code != 1) return;
        this.tableDatas = res.data.Data[1].datatable;
        this.totalDatas.MNTotal = res.data.Data[0].datatable[0].MNTotal;
        this.totalDatas.YLTotal = res.data.Data[0].datatable[0].YLTotal;
        this.chartTitle =
          this.queryParams.sDate + "至" + this.queryParams.eDate + " ";
        if (this.$refs["cas_region"]) {
          //  var index=this.$refs['cas_region'].currentLabels.length>0?this.$refs['cas_region'].currentLabels.length-1:0;
          //  this.chartTitle=this.chartTitle+' '+this.$refs['cas_region'].currentLabels[index];
          this.chartTitle =
            this.chartTitle +
            " " +
            (this.$refs["cas_region"].currentLabels.length > 0
              ? this.$refs["cas_region"].currentLabels[
                  this.$refs["cas_region"].currentLabels.length - 1
                ]
              : "全国");
        } else {
          this.chartTitle = this.chartTitle + "全国";
        }
        this.splitData();
        this.initChart();
        this.chartLoading = false;
      });
      //console.log(this.queryParams);
    },
    doFilter() {
      this.showFilter = false;
      this.search();
    },
    splitData() {
      this.seriesData = this.ChartData_Series(this.tableDatas);
      console.log(this.tableDatas);
      this.dimensionsData = this.ChartData_Dimensions(this.tableDatas);
    },
    ChartData_Series() {
      var newArr = [];
      var Obj = {
        type: "line",
        animationDuration: 2800,
        animationEasing: "cubicInOut"
      };

      var firstObj = {};
      firstObj = this.tableDatas[0];
      for (var x in firstObj) {
        if (x != "product") newArr.push(Obj);
      }
      return newArr;
    },

    ChartData_Dimensions() {
      //第一列必须是product
      var newArr = ["product"];
      var firstObj = {};
      firstObj = this.tableDatas[0];
      for (var x in firstObj) {
        if (x != "product") newArr.push(x);
      }
      return newArr;
    },
    getRegionCascader() {
      getKPIRegionCascaderOption(1).then(res => {
        if (res.data.Code != 1) return;
        var arr = [];
        arr = res.data.Data[0].children; //去掉第一层全国
        //arr = this.filter(res.data.Data,3)[0].children;//去掉level=3及以下数据
        //去掉第一层全国，并且重置全国下面的parentKey
        for (var i = 0; i < arr.length; i++) {
          //去掉最后一层
          arr[i].parentKey = null;
          var child = [];
          if (arr[i].children && arr[i].children.length) {
            child = arr[i].children;
            for (var j = 0; j < child.length; j++) {
              child[j].children = null;
            }
          }
          this.regionCascaders.push(arr[i]);
        }
      });
    },

    initChart() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("main"));

      // 指定图表的配置项和数据
      var option = {
        title: {
          text: "",
          //text:this.chartTitle,
          textStyle: {
            //文字颜色
            color: "#000000",
            //字体风格,'normal','italic','oblique'
            fontStyle: "normal",
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: "bold",
            //字体系列
            fontFamily: "sans-serif",
            //字体大小
            fontSize: 10
          },
          left: "center"
        },
        //tooltip: {},
        legend: {
          //data:['expected','actual']
          //data:this.legendData,
          bottom: -2
        },
        dataset: {
          // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
          // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
          //dimensions: ['product', '2015', '2016', '2017'],
          dimensions: this.dimensionsData,
          source: this.tableDatas
        },
        xAxis: {
          //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          //data:this.xAxisData,
          type: "category",
          //boundaryGap: false,X轴从0开始
          axisTick: {
            //show: false
            alignWithLabel: true //X轴下面加点
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置。
            interval: 0, //每隔都显示；1每隔1个显示
            rotate: "45"
          }
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          //axisPointer: {
          //  type: 'cross'
          //},//去掉点击后出现的横向虚线
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        dataZoom: [
          // {   // 这个dataZoom组件，默认控制x轴。
          //     type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
          //     start: 0,      // 左边在 10% 的位置。
          //     end: 100         // 右边在 60% 的位置。
          // },
          {
            // 这个dataZoom组件，也控制x轴。
            type: "inside", // 这个 dataZoom 组件是 inside 型 dataZoom 组件
            start: 0, // 左边在 10% 的位置。
            end: 100 // 右边在 60% 的位置。
          }
        ],
        series: this.seriesData
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
  }
};
</script>
  
  <style scoped>
@import "../../assets/css/kpi/kpi.css";
</style>

  <style>
.customWidth {
  min-width: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/kpi/ModernAvgGoods.vue